import React from "react";
// import ConvertKitForm from "convertkit-react";
import classNames from "classnames";
import { SectionSplitProps } from "../../utils/SectionProps";
// import Button from "../elements/Button";
// import Input from "../elements/Input";
import Image from "../elements/Image";
import Button from "../elements/Button";

const propTypes = {
  ...SectionSplitProps.types,
};

const defaultProps = {
  ...SectionSplitProps.defaults,
};

class HeroSplit extends React.Component {
  componentDidMount() {
    // this is only to handle inline style on window resize
    window.onresize = function () {
      this.forceUpdate();
    }.bind(this);
  }

  render() {
    const {
      className,
      topOuterDivider,
      bottomOuterDivider,
      topDivider,
      bottomDivider,
      hasBgColor,
      invertColor,
      invertMobile,
      invertDesktop,
      alignTop,
      imageFill,
      ...props
    } = this.props;

    const outerClasses = classNames(
      "hero section",
      topOuterDivider && "has-top-divider",
      bottomOuterDivider && "has-bottom-divider",
      hasBgColor && "has-bg-color",
      invertColor && "invert-color",
      className
    );

    const innerClasses = classNames(
      "hero-inner section-inner",
      topDivider && "has-top-divider",
      bottomDivider && "has-bottom-divider"
    );

    const splitClasses = classNames(
      "split-wrap",
      invertMobile && "invert-mobile",
      invertDesktop && "invert-desktop",
      alignTop && "align-top"
    );

    // const config = {
    //   formId: 2191497,
    //   // template: "clare",
    //   hideName: true,
    //   emailPlaceholder: "Enter email for beta access!!",
    //   submitText: "Sign up",
    // };

    return (
      <section {...props} className={outerClasses}>
        <div className="container">
          <div className={innerClasses}>
            <div className={splitClasses}>
              <div className="split-item" style={inlineStyle()}>
                <div className="hero-content split-item-content center-content-mobile">
                  <h1
                    className="mt-0 mb-16 reveal-from-top"
                    data-reveal-delay="150"
                  >
                    When does lululemon restock?
                  </h1>
                  <p
                    className="mt-0 mb-32 reveal-from-top"
                    data-reveal-delay="300"
                  >
                    Usually on Tuesdays at 2pm EST. But, ultimately they can
                    restock at any time! Don't miss out on your favorite
                    lululemon geat, get a FAST notification when lululemon
                    restocks.
                    {/* Sick of products always being out of stock? Get an immediate
                    text when the lululemon product you want is back in stock! */}
                  </p>
                  <div className="reveal-from-top" data-reveal-delay="450">
                    <Button tag="a" color="primary" href="/signup">
                      Sign up
                    </Button>
                    {/* <div className="convert-kit-stuff form-group has-icon-right">
                      <ConvertKitForm {...config} />
                    </div> */}
                  </div>
                </div>
                <div className="reveal-from-top" data-reveal-delay="450">
                  <Image
                    // style={{ height: 400, objectFit: "scale-down" }}
                    // className="has-shadow"
                    src={require("./../../assets/images/hero.png")}
                    alt="notify-button"
                    // width={528}
                    // height={396}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

// inline style
const inlineCss = {
  alignItems: "flex-start",
  // minHeight: "492px",
};

const inlineStyle = function () {
  if (window.innerWidth > 641) {
    return inlineCss;
  }
};

HeroSplit.propTypes = propTypes;
HeroSplit.defaultProps = defaultProps;

export default HeroSplit;
